export default {
  default: () => import("/github/workspace/frontend/layouts/default.vue").then(m => m.default || m),
  "full-width": () => import("/github/workspace/frontend/layouts/full-width.vue").then(m => m.default || m)
}